import { Typography } from "@mui/material";
import React from "react";

const DeliverableProgressWithLabel = (props) => {
  const { startLabel, endLabel, progressContent, className } = props;
  return (
    <div
      style={
        {
          // display: "flex",
          // alignItems: "center",
          // justifyContent: "space-between",
        }
      }
      className={className}
    >
      <Typography variant="body3">{startLabel}</Typography>

      <div style={{ width: "100%" }}>{progressContent}</div>

      <Typography variant="body3">{endLabel}</Typography>
    </div>
  );
};

export default DeliverableProgressWithLabel;
